let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kkES0")).then(() => parcelRequire('bPQUa'));